import { Router } from "@angular/router";

import { NavbarMenuItemType } from "@frontends-v3/design-system";

export function createNavbarMenuItem(
  id: string,
  label: string,
  icon: string,
  router: string,
  variantMenu: "primary" | "simple" = "primary",
  disabled = false
): NavbarMenuItemType {
  return {
    id,
    label,
    icon,
    variantMenu,
    route: router,
    disabled
  };
}

export function handleUserMenuNavigation(router: Router, itemId: string): void {
  switch (itemId) {
    case "profile":
      router.navigate(["/profile"]);
      break;
    case "settings":
      router.navigate(["/settings"]);
      break;
    default:
      console.warn(`[handleUserMenuNavigation] Unrecognized itemId: "${itemId}"`);
  }
}

export function handleHelpMenuNavigation(router: Router, itemId: string): void {
  switch (itemId) {
    case "faq":
      router.navigate(["/help/faq"]);
      break;
    case "specialist":
      router.navigate(["/help/specialist"]);
      break;
    case "support":
      router.navigate(["/help/support"]);
      break;
    default:
      console.warn(`[handleHelpMenuNavigation] Unrecognized itemId: "${itemId}"`);
  }
}
